import { render } from "./CardDate.vue?vue&type=template&id=47d35512&ts=true"
import script from "./CardDate.vue?vue&type=script&lang=ts"
export * from "./CardDate.vue?vue&type=script&lang=ts"

import "./CardDate.vue?vue&type=style&index=0&id=47d35512&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__